import { render } from "./CadastroFormasPagamentoView.vue?vue&type=template&id=f8494c30"
import script from "./CadastroFormasPagamentoView.vue?vue&type=script&lang=js"
export * from "./CadastroFormasPagamentoView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__